<template>
    <base-card>
        <h2>Find a skipper</h2>
        <span class="filter-options">
          <input type="checkbox" id="vendee_arctique" checked @change="setFilter">
          <label for="vendee_arctique">Vendée Arctique</label>
          <input type="checkbox" id="transat_jacques_vabre" checked @change="setFilter">
          <label for="transat_jacques_vabre">Transat Jacques Vabre</label>
          <input type="checkbox" id="rolex_fastnet_race" checked @change="setFilter">
          <label for="rolex_fastnet_race">Rolex Fastnet Race</label>
          <input type="checkbox" id="route_de_rhum" checked @change="setFilter">
          <label for="route_de_rhum">Route de Ruhm</label>
           <input type="checkbox" id="bermudes_1000_race" checked @change="setFilter">
          <label for="bermudes_1000_race">Bermudes 1000 Race</label>

        </span>
    </base-card>

</template>

<script>

export default {

    emits:['change-filter'],

    data() {
        return {
            filters: {
                vendee_arctique: true,
                transat_jacques_vabre:true,
                rolex_fastnet_race:true,
                route_de_rhum:true,
                bermudes_1000_race:true
            }
        }
    },
    methods: {
        setFilter(event) {
            const inputId =  event.target.id;
            const isActive = event.target.checked;
            console.log(event);
            const updatedFilters = {
                ...this.filters,
                [inputId]: isActive
            };
            this.filters = updatedFilters;
            this.$emit('change-filter',updatedFilters);
            }  
        }
    }

</script>

<style scoped>
h2 {
  margin: 0.5rem 0;
}

.filter-option {
  margin-right: 1rem;
}

.filter-option label,
.filter-option input {
  vertical-align: middle;
}

.filter-option label {
  margin-left: 0.25rem;
}

.filter-option.active label {
  font-weight: bold;
}
</style>